/*eslint-disable */
var $ = window.jQuery = require('jquery');
import { bus } from '@/main';
export default {
  name: 'blog-disclaimer',
  components: {},
  props: [],
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    closeDisclaimerModal(){
      bus.$emit('blogDisclaimerBus', false)
      $('body').removeClass('body_right_scroll_remove')
    }
  }
}